// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__AQifo","primary":"Button_primary__1kzZJ","danger":"Button_danger__1cukr"};